/*
    Module definition for browserify
*/
require('./dist/filepicker');
module.exports = filepicker;



//////////////////
// WEBPACK FOOTER
// ./~/filepicker-js/index.js
// module id = 1331
// module chunks = 0